import {
  ActionType,
  IGetConsultationListResponse,
  IConsultationListPayload,
} from "models/consultation/list";

export const getConsultationListAction = (
  payload: IConsultationListPayload
) => {
  return {
    type: ActionType.GET_CONSULTATION_LIST,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.GET_CONSULTATION_LIST_ERROR,
    payload,
  };
};

export const handleSuccessAction = (payload: IGetConsultationListResponse) => {
  return {
    type: ActionType.GET_CONSULTATION_LIST_SUCCESS,
    payload,
  };
};
